import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import { Evento } from '../eventos/evento.model';
import { EventoDataService } from '../service/data/evento-data.service';
import * as countdown from 'countdown';
import { Time } from '../models/time.model';
import { GoogleTagManagerService } from 'angular-google-tag-manager';

declare var dataLayer;
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements OnInit {
  eventos: Evento[] = [];
  fecha: Date;
  time: Time = null;
  player: YT.Player;
  id: string = 'qJvAwTxRADQ';
  screenH: any = window.innerHeight;
  screenW: any = window.innerWidth;
  fondo: string;
  meses: number;
  semanas: number;
  dias: number;
  horas: number;
  minutos: number;
  segundos: number;
  distancia: number;
  @ViewChild('videoPlayer') videoplayer: ElementRef;

  constructor(
    private service: EventoDataService,
    private gtmService: GoogleTagManagerService
  ) {}

  ngOnInit(): void {
    this.resize();
    this.service.getEventoId('AT2024-62').subscribe((response) => {
      this.handleSuccesfullGet(response);
      this.fecha = new Date(this.eventos[0].fecha);
      let x = setInterval(() => {
        let fechaFutura = this.fecha.getTime() + 93600000;
        let hoy = new Date().getTime();
        this.distancia = fechaFutura - hoy;
        this.meses = Math.floor(this.distancia / (1000 * 60 * 60 * 24) / 30);
        this.semanas = Math.floor(this.distancia / (1000 * 60 * 60 * 24 * 7));
        this.dias = Math.floor(this.distancia / (1000 * 60 * 60 * 24));
        this.horas = Math.floor(
          (this.distancia % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        this.minutos = Math.floor(
          (this.distancia % (1000 * 60 * 60)) / (1000 * 60)
        );
        this.segundos = Math.floor((this.distancia % (1000 * 60)) / 1000);
        //console.log(this.dias+" days, "+this.horas+" hor, "+this.minutos+" min, "+this.segundos+" seg");
        if (this.distancia < 0) {
          clearInterval(x);
          this.meses = 0;
          this.semanas = 0;
          this.dias = 0;
          this.horas = 0;
          this.minutos = 0;
          this.segundos = 0;
        }
      }, 1000);
    });
  }

  savePlayer(player) {
    this.player = player;
    this.player.mute();
    this.player.playVideo();

    this.player.loadPlaylist(this.id);

    this.player.setLoop(true);
    this.player.setSize(window.innerWidth, window.innerHeight);
  }

  @HostListener('window:resize', ['$event'])
  onStateChange(event) {
    console.log('player state', event.data);
  }

  handleSuccesfullGet(response) {
    this.eventos = [];
    this.eventos.push(response);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.resize();
  }

  resize() {
    if (window.innerWidth > window.innerHeight) {
      this.fondo = 'HOME FINAL.jpg';
    } else {
      this.fondo = 'HOME VERTICAL1.jpg';
    }
  }
}
